import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueRouter from 'vue-router'
import VueCookies from 'vue-cookies'
import MQ from 'vue-match-media/src'

import GroupingView from './views/GroupingView.vue'
import ReviewView from './views/ReviewView.vue'
import LemmaView from './views/LemmaView.vue'
import CollocationView from './views/CollocationView.vue'
import Home from './views/Home.vue'
import Search from './views/Search.vue'
import ChangesView from './views/ChangesView'
import UserHomeView from './views/UserHomeView'
import StatsView from './views/StatsView'
import StaticView from './views/StaticView'

import store from './store'
import { api } from './mixins/api.js'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueCookies)
Vue.use(MQ)

/**
 * pattern#core_index1#core_index_2#...
 * @param {*} route
 */
function parseQualifiedPattern (route) {
  const [pattern, coreIndexes] = api.methods.parseQualifiedPattern(route.params.qualifiedPattern)
  delete route.params.qualifiedPattern
  return { ...route.params, pattern, coreIndexes: coreIndexes.map(x => Number(x)) }
}

Vue.use(VueRouter)
const router = new VueRouter({
  routes: [
    // dynamic segments start with a colon
    { path: '/', component: Home },
    { path: '/changes', component: ChangesView },
    { path: '/home', component: UserHomeView },
    { path: '/static/:url/:theme', component: StaticView, name: 'static', props: true },
    { path: '/stats', component: StatsView },
    { path: '/search/:query', component: Search, props: true },
    { path: '/review/:lempos/:qualifiedPattern/:collLempos?', name: 'review', component: ReviewView, props: parseQualifiedPattern },
    { path: '/group/:lempos/:qualifiedPattern/:collLempos?', name: 'grouping', component: GroupingView, props: parseQualifiedPattern },
    { path: '/:lempos', name: 'lemma', component: LemmaView, props: true },
    { path: '/:lempos/:collPattern/:collLempos', name: 'collocation', component: CollocationView, props: true }
  ]
})

Vue.mixin({
  methods: {
    arabizeNumerals: (s) => String(s).replace(/\d/g, function (v) {
      return String.fromCharCode(v.charCodeAt(0) + 0x0630)
    }),
    arabicPos: function (pos) {
      if (pos === 'NOUN') { return 'اسم' }
      if (pos === 'VERB') { return 'فعل' }
      if (pos === 'ADJ') { return 'صفة' }
      return 'مجهول'
    },
    lempos2lemma (s) {
      return s.split(' ').map(x => x.split('+')[0]).join(' ')
    }
  }
})

// Vue.config.performance = true

new Vue({
  router,
  store,
  mq: {
    phone: '(max-width: 991px)'
  },
  render: h => h(App)
}).$mount('#app')
